/**
 * Enhets-lokala inställningar för mobil-POS (/mobilepos), lagras i localStorage
 * per station. Varje telefon konfigurerar sin egen Stripe-terminal och vilka
 * av stationens produkter som ska auto-incheckas vid skanning.
 */

export type MobilePosStationSettings = {
    stripeTerminalId?: string;
    // Ids (produkt/variant/occasion) som ska auto-incheckas. undefined = alla i stationens lista.
    autoCheckinIds?: string[];
};

const KEY_PREFIX = "mobilepos_settings_";

export const getStationSettings = (stationId: string): MobilePosStationSettings => {
    if (!stationId) {
        return {};
    }
    try {
        const raw = localStorage.getItem(KEY_PREFIX + stationId);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const saveStationSettings = (stationId: string, settings: MobilePosStationSettings): void => {
    if (!stationId) {
        return;
    }
    localStorage.setItem(KEY_PREFIX + stationId, JSON.stringify(settings ?? {}));
};

/**
 * Ska ett id (produkt/variant/occasion) auto-incheckas? Om inga specifika
 * val gjorts (autoCheckinIds saknas) auto-incheckas allt i stationens lista.
 */
export const isAutoCheckinEnabled = (settings: MobilePosStationSettings, ids: (string | undefined)[]): boolean => {
    if (!settings || !settings.autoCheckinIds) {
        return true;
    }
    return ids.some(id => !!id && settings.autoCheckinIds.indexOf(id) >= 0);
};
